module.exports = __webpack_public_path__ + "static/media/task7Planet2.7fd4d1cb.png";